#change-partner-wrapper {
  height: 100%;

  display: flex;
  flex-direction: column;

  padding: calc(var(--spacer) * 3) 0 calc(var(--spacer) * 3) calc(var(--spacer) * 3);

  .box-error {
    .ds-icon {
      font-size: 20px;
    }
  }

  #change-partner-inner-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-right: calc(var(--spacer) * 4);
    overflow-y: auto;

    .company-name {
      margin-top: calc(var(--spacer) * 3);
      color: var(--body-text-arrows-400);
    }

    #change-partner-title {
      margin-top: calc(var(--spacer) * 6);
      color: var(--main-titles-inputs-600);
    }

    #change-partner-info-text {
      margin-top: calc(var(--spacer) * 3);
      margin-bottom: 0;
      color: var(--chart-300-icon-buttons);

      font-size: var(--body-size);
      line-height: 1.8;
    }

    #change-partner-form-title {
      margin-top: calc(var(--spacer) * 4);
      text-transform: uppercase;
      color: var(--chart-300-icon-buttons);
    }

    #change-partner-company-id-label {
      margin-top: calc(var(--spacer) * 2);
      margin-bottom: 0;
      color: var(--body-text-arrows-400);
      font-size: var(--body-size);

      &:after {
        content: '*:';
      }
    }

    #change-partner-company-id {
      margin-top: var(--spacer);
      width: 240px;
    }

    #change-partner-ec2-notice-container {
      margin-top: calc(var(--spacer) * 3);
      line-height: 21px;
    }

    #change-partner-backend-error-container {
      display: flex;

      #change-partner-backend-error-text {
        color: var(--body-text-arrows-400);
        font-size: var(--body-size-large);
        --font-family: var(--font-family-secondary);
      }
    }


  }
}

.bottom-buttons {
  width: 100%;

  margin-top: calc(var(--spacer) * 2);

  display: flex;
  align-items: center;

  gz-button {
    margin-right: calc(var(--spacer) * 2);
  }
}
